import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MapElementSelectionDetail } from './components/MapElementSelectionDetail';
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { NumberActionDetail } from './components/NumberActionDetail';
export const TriggerDamageInAreaActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_area_trigger"),
    selectedElement: action.mapElement,
    elementSetter: action.setMapElement.bind(action),
    getSelectableElements: MapElementFilter.filterTriggerLabelsWithoutViewAreaTriggers,
    parameterTypes: ["actions/AreaTriggerValueModel"]
  }), /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_damage"),
    value: action.damage,
    valueSetter: action.setDamage.bind(action)
  }), /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_delay"),
    value: action.delay,
    valueSetter: action.setDelay.bind(action)
  }), /*#__PURE__*/React.createElement(NumberActionDetail, {
    name: t("action_editor.property_duration"),
    value: action.duration,
    valueSetter: action.setDuration.bind(action)
  }));
});